import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addBeneficiary: 'Add a beneficial owner',
    addBeneficiaryAdornment: 'Beneficiaries missing?',
    beneficiarySectionHeading: 'Follow-up of beneficial owners',
    completedBeneficiaryCount: '{completed}/{total}',
    heading: 'Follow-up on your case',
    informationCompleteSectionTitle: 'Information completed',
    inProgressSectionTitle: 'In progress',
    invalidSectionDescription: `We have contacted the beneficiaries listed below so that they may make changes to their information. This information is required to open your pro Shine account`,
    invalidSectionTitle: 'Invalid information',
    notStartedSectionTitle: 'Awaiting reply',
  },
  fr: {
    addBeneficiary: 'Ajouter un bénéficiaire effectif',
    addBeneficiaryAdornment: 'Bénéficiaires manquants ?',
    beneficiarySectionHeading: 'Suivi des bénéficiaires effectifs',
    completedBeneficiaryCount: '{completed}/{total}',
    heading: 'Suivi de votre dossier',
    informationCompleteSectionTitle: 'Informations complétées',
    inProgressSectionTitle: 'Démarche en cours',
    invalidSectionDescription: `Nous avons contacté les bénéficiaires listés ci dessous pour qu’ils puissent apporter des modifications à leurs informations. Ces informations sont obligatoires pour ouvrir votre compte pro Shine.`,
    invalidSectionTitle: 'Informations invalides',
    notStartedSectionTitle: 'En attente de réponse',
  },
} as const);
